export default function loadLocale(locale) {
  return new Promise((resolve) => {
    switch (locale) {
      case 'en-US': {
        require.ensure(['./en-US'], (require) => {
          const data = require('./en-US');
          resolve(data.__esModule === true ? data.default : data);
        }, 'en-US');
        break;
      }
      default:
        resolve({});
        break;
    }
  });
}
